import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import "./settings-modern.css";

function ChangeNameModal({ open, handleClose, admin, user }) {
  const [invalid, setInvalid] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setInvalid(false);
    const data = new FormData(e.currentTarget);
    const name = (data.get("name") || "").trim();
    const lastName = (data.get("last_name") || "").trim();
    if (name.length < 3 || lastName.length < 3) {
      setInvalid(true);
      return;
    }

    const request = admin === "yes"
      ? axios.put(`${process.env.React_APP_BACKEND_URL}/api/admin/changename`, { name, last_name: lastName, id: user.id }, { headers: { Authorization: `Bearer ${Cookies.get("admintoken")}` } })
      : axios.put(`${process.env.React_APP_BACKEND_URL}/api/changename`, { name, last_name: lastName }, { headers: { Authorization: `Bearer ${Cookies.get("token")}` } });

    request.then(() => {
      Cookies.set("name", name, { expires: 365 });
      Cookies.set("last_name", lastName, { expires: 365 });
      handleClose("name");
    }).catch((err) => console.log(err));
  };

  return (
    <Modal open={open} onClose={() => handleClose("name")} aria-labelledby="change-name-title">
      <Box className="bidit-settings-modal">
        <Box className="bidit-settings-head">
          <Typography id="change-name-title" className="bidit-settings-title">עדכון שם</Typography>
          <Typography className="bidit-settings-subtitle">הזינו את השם כפי שתרצו שיופיע באזור האישי.</Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit}>
          <Typography className="bidit-settings-field-label">שם פרטי</Typography>
          <TextField required fullWidth name="name" autoComplete="given-name" defaultValue={user?.name || ""} />
          <Typography className="bidit-settings-field-label">שם משפחה</Typography>
          <TextField required fullWidth name="last_name" autoComplete="family-name" defaultValue={user?.last_name || ""} />
          {invalid && <Box className="bidit-settings-error">יש להזין לפחות 3 תווים בכל שדה.</Box>}
          <Button fullWidth type="submit" variant="contained" className="bidit-settings-primary" sx={{ mt: 2.5 }}>שמירת השינויים</Button>
        </Box>
      </Box>
    </Modal>
  );
}
export default ChangeNameModal;
